<template>
  <div class="navigation-burger-menu__wrapper" @click="$emit('click')">
    <div class="navigation-burger-menu__container">
      <span
        class="navigation-burger-menu__lines"
        :class="{ 'navigation-burger-menu__lines--open': isOpen }"
      />
      <span
        class="navigation-burger-menu__lines"
        :class="{ 'navigation-burger-menu__lines--open': isOpen }"
      />
      <span
        class="navigation-burger-menu__lines"
        :class="{ 'navigation-burger-menu__lines--open': isOpen }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BurgerMenu',

  props: {
    isOpen: Boolean,
  },
}
</script>

<style lang="postcss" scoped>
.navigation-burger-menu__wrapper {
  cursor: pointer;
  padding: var(--spacing-2);
  margin-right: -6px;

  &:hover {
    .navigation-burger-menu__lines {
      background-color: var(--c-primary-color-2);
    }
  }
}

.navigation-burger-menu__container {
  display: inline-block;
  position: relative;
  width: 16px;
  height: 13px;
}

.navigation-burger-menu__lines {
  --distance-to-top: 6px;

  display: block;
  position: absolute;
  width: 16px;
  height: 1px;
  left: 0;
  background-color: var(--c-primary-neutral-1);

  transition: transform 300ms ease-in-out;

  &:first-child {
    top: 0;
    transform: rotate(0);

    &.navigation-burger-menu__lines--open {
      transform: translate(0px, var(--distance-to-top)) rotate(45deg);
    }
  }

  &:nth-child(2) {
    top: var(--distance-to-top);
    opacity: 1;

    &.navigation-burger-menu__lines--open {
      opacity: 0;
    }
  }

  &:last-child {
    bottom: 0;
    transform: rotate(0);

    &.navigation-burger-menu__lines--open {
      transform: translate(0px, calc(var(--distance-to-top) * -1))
        rotate(-45deg);
    }
  }
}

@media (--md) {
  .navigation-burger-menu__wrapper {
    margin-bottom: calc(var(--spacing-2) * -1);
  }
}
</style>
